import { createFileRoute, notFound } from "@tanstack/react-router";
import { loadBlockPage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/lp/$slug")({
  loader: async ({ params }) => {
    const page = await loadBlockPage({ data: { collection: "lp", slug: params.slug } });
    return {
      slug: page.slug,
      title: page.title,
      seo_title: page.seo_title,
      seo_description: page.seo_description,
      featured_image: page.featured_image,
      robots: page.robots,
      blocks: page.blocks || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? seo({
          title: loaderData.seo_title || loaderData.title,
          description: loaderData.seo_description || "",
          image: loaderData.featured_image,
          url: `/lp/${loaderData.slug}`,
          noindex: loaderData.robots === "noindex",
        })
      : [],
    links: loaderData ? seoLinks({ url: `/lp/${loaderData.slug}` }) : [],
  }),
  component: LandingPage,
});

function LandingPage() {
  const page = Route.useLoaderData();
  return <BlockRenderer blocks={page.blocks} />;
}
